import { Box } from '@mui/material';

import { ImageFileFragment } from 'types/api/dato-operations.types';

import EventListItem from 'components/@events/EventListItem';

interface Props {
  cover: ImageFileFragment;
  title: string;
  startDatetime: string | undefined;
  endDatetime: string | undefined;
  timezone: string;
  city: string;
  quantity: number;
  priority?: boolean;
}

const EventTicketsContent = ({
  title,
  cover,
  startDatetime,
  endDatetime,
  timezone,
  city,
  quantity,
  priority = false,
}: Props) => {
  return (
    <>
      <EventListItem.Cover cover={cover} priority={priority} />
      <EventListItem.Content sx={{ flexGrow: 1 }}>
        <EventListItem.Title>{title}</EventListItem.Title>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              flexGrow: '1',
            }}
          >
            <EventListItem.Date
              startDatetime={startDatetime}
              endDatetime={endDatetime}
              timezone={timezone}
            />
            <EventListItem.City city={city} />
          </Box>
          <EventListItem.TicketsIndicator quantity={quantity} />
        </Box>
      </EventListItem.Content>
    </>
  );
};

export default EventTicketsContent;
